import React from "react"
import "bootstrap-honoka/dist/css/bootstrap.min.css"
import "./style.css"
import { Header } from "./header"

export const Layout = ({ children, slug }) => {
    return (
        <>
            <Header slug={slug} />
            <main className="container">{children}</main>
        </>
    )
}
